<template>
  <div class="container1 fixed-top" >
    <div class="navbarPX navbarPX-expand-lg ftco_navbarPX ftco-navbarPX-light" id="ftco-navbarPX">
      <open-language></open-language>
      <div class="container1" style="margin:auto"  >
				<div id="nav-icon3" class="colapsed" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation" @click="menu()">
					<span></span>
					<span></span>
					<span></span>
					<span></span>
			  </div>
        <div v-if="isLogged && dashboardType === 'user'" >
          <a style="cursor:pointer;" href="/dashboard"><img class="icondashboard"   src="https://business.pixcham.com/images/icondashboard.svg" alt=""></a>
        </div>
        <div v-if="isLogged && dashboardType === 'admin'">
          <a style="cursor:pointer;" href="/dashboardadmin"><img class="icondashboard"   src="https://business.pixcham.com/images/icondashboard.svg" alt=""></a>
        </div>
				<div  v-if=" !isLogged || ( isLogged && dashboardType === 'user' ) " > 
          <a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/business'"><img id="title" class="logo1"  src="https://business.pixcham.com/images/pixcham_business_wh_new.svg" /></a>
					
			  </div>
        <div  v-if="isLogged && dashboardType === 'admin'" > 
          <a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/business'"><img id="title" class="logo1"  src="https://business.pixcham.com/images/pixchamadmin.png" /></a>	
			  </div>
       
				
        <div class="collapse navbarPX-collapse" id="ftco-nav" style="min-height:63px;">
          <ul class="navbarPX-nav ml-auto mr-md-3" >
            <li v-if="!isLogged" class="nav-itemPX active" ><a style="text-decoration:none" :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com'" class="nav-linkPX">{{$t('application')}}</a></li>
					  <li v-if="!isLogged" class="nav-itemPX"><a style="text-decoration:none"  :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/influencer'" class="nav-linkPX"  @click="closeMenu()" >{{$t('influencer')}}</a></li>
            <li v-if="!isLogged" class="nav-itemPX"><a style="text-decoration:none"  :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/business'" class="nav-linkPX">{{$t('business-2')}}</a></li>
            <li v-if="isLogged && false " class="nav-itemPX"><a style="text-decoration:none" href="https://www.worldcupofselfies.com" _target="blank" class="nav-linkPX">World Cup of Selfies</a></li>
            <li class="dropdownPX nav-itemPX d-md-flex align-items-center"></li>
          </ul>
				  <div class="buttoncreate" style="cursor:pointer;">
            <img class="icon" src="https://business.pixcham.com/images/plusicon.svg">
            <a href="/challenge/location" style="text-decoration: none;" class="create" >{{ $t('create-now-c') }}</a>
					</div>
			    <div v-if="!isLogged" style="cursor:pointer;" class="buttonlogin">
			      <a href="/login" style="text-decoration: none;" class="login">{{ $t('login') }}</a>
				  </div>
            
          <div v-if="isLogged && false"  class="buttonheader-header-balance" style="">
              <img class="icon" src="https://business.pixcham.com/images/wallet.svg">
              <a href="/balance" style="text-decoration: none;" class="account" >{{$t('ballance')}}: {{ formatPrice( this.$store.getters.credit ) }}</a>
            </div>
          <div  v-if="isLogged"  class="dropdownhead-header">     
            
            <div class="buttonheader-header">
              <img class="icon" src="https://business.pixcham.com/images/Accounticon.svg">
              <!--
              <a   :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/register'" style="text-decoration: none;" class="account" >{{ $t('profile') }}</a>
              -->
                <a style="text-decoration: none;cursor: pointer" class="account" >{{ $t('profile') }}</a>
              <img style="cursor:pointer;" class="arrowaccount" src="https://business.pixcham.com/images/arrowblack.png">
            </div>       
            <div class="dropdownhead-content-header" style="width: 100%;">
              <div class="companybox">
                <p class="companyname" style="cursor:pointer;" @click="changeCompany()"  >{{ ( getCompany && getCompany.name ? getCompany.name : 'Select company' ) }}</p> 
              </div>
              <div v-if="( hasAccess.includes( 'admin' ) )" class="companybox" style="display:flex;">
                <p class="companyname col-6 align-center" @click="changeDashboard('user')" style="cursor:pointer;" :style="( dashboardType === 'user'? 'color:#009de6' : '' )">{{$t('User')}}</p> 
                <p class="companyname col-6 align-center" @click="changeDashboard('admin')" style="cursor:pointer;" :style="( dashboardType === 'admin'? 'color:#009de6' : '' )">Admin</p> 
              </div>
              <a class="dropitem" rel="noopener"  href="/profile">{{$t('user-account-profil')}}</a>
              <a class="dropitem" rel="noopener"  href="/support-request">{{$t('support')}}</a>
              <a class="dropitem" rel="noopener"  href="/change">{{$t('pass.change')}}</a>
              <span style="border-bottom: 1px solid silver;"></span>
              <a class="dropitem" rel="noopener"  href="/" @click="logout()" >{{$t('logout')}}</a>


             
            </div>  
          </div>

    
			

				  <div class="drop">
            <div class="buttonadmin">
              <img class="arrowadmin" src="https://business.pixcham.com/images/adminarrow.png" />
              <a href="" style="text-decoration: none;" class="admin" >{{ $t('admin') }}</a>
              <div class="buttonadmin-content">
                <a class="admintext">{{ $t('profile') }}</a>
                <a class="admintext">{{ $t('reports') }}</a>

              
              </div>
            </div>
          </div>
          <div class="languagebutton" @click="openLanguages()" style="cursor:pointer;">
						<img class="langicon-header" src="https://business.pixcham.com/icons/globe.svg" alt=""/>
						<div style="text-decoration: none;"
							class="language">{{$t('language')}}</div>
					</div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SuccessPop from "@/components/SuccessPop";
import Language from "@/components/Language";

export default {
  components: {SuccessPop},
  data() {
    return {
      accessToken: localStorage.getItem("access"),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin'
      },
      //currentUrl: this.$route.path,
      submenu: false,
      hover: {
        home1: false,
        home2: false,
        overview: false,
        business: false,
        wcos: false,
        challenge: false,
        login: false
      },
      title: 'us',
      submenuAdmin: false,
      menu_old: false,
      notiIDs: [],
      showNotes: false,
      tasks: 0,
      support: 0,
      windowWidth: window.innerWidth,
      seened: [],
      maxNotifyID: 0,
      seenedIDs: [],
      refreshLangKey: 1,
      reports: 0,
      challenges: 0,
      userNotes: [],
      url: this.$store.getters.enviromentURL + '/reminder',
      url2: this.$store.getters.enviromentURL + '/viewed'
    };
  },
  computed: {
    isLogged() {
      return this.$store.getters.userLoggedIn;
    },
    dashboardType() {
      return this.$store.getters.dashboardType;
    },
    isInfluencer() {
      return this.$store.getters.userInfluencer;
    },
    getCompanyName() {
      return this.$store.getters.companyName;
    },
    getCompany() {
      return this.$store.getters.company;
    },
    hasAccess() {
      return this.$store.getters.userPrivileges;
    },
    currentUrl() {
    //console.log('RAAAASSAAAAAA', this.$route.path);
      return this.$route.path;
    },
    getLang() {
      return this.$store.state.activeLang;
    }
  },
  mounted() {
    if(this.isMobile())
    {
      window.addEventListener("scroll", (event) => {
			  
        if ( window.pageYOffset > 750 ){
            
            var element = document.getElementById("download"); 
            element.classList.add('buttondownload-active');
            element.classList.remove('buttondownload-deactive');
      
          } else {
            var element = document.getElementById("download");
            element.classList.add('buttondownload-deactive');
            element.classList.remove('buttondownload-active');
                
          }
        });
    }

    let jquery = document.createElement('script')
      jquery.setAttribute('type', 'text/javascript')
      jquery.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js')
      document.head.appendChild(jquery)

      let popper = document.createElement('script')
      popper.setAttribute('type', 'text/javascript')
      popper.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/popper.js/2.9.3/umd/popper.min.js')
      document.head.appendChild(popper)

      let boots = document.createElement('script')
      boots.setAttribute('type', 'text/javascript')
      boots.setAttribute('src', 'https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/js/bootstrap.min.js')
      document.head.appendChild(boots)

    //setTimeout( this.reminder, 5000 );

    window.addEventListener('resize', () => {
      this.resized();
    });
    this.init();
  },
  watch:{
    submenuAdmin( value )
    {
      if( value ){ this.submenu = false; }
    },
    submenu( value )
    {
      if( value ){ this.submenuAdmin = false; }
    }
  },
  methods: {
    changeCompany() {
      this.$router.push({ path: '/company' });
    },
    openLanguages() {
      console.log('UPDATEs');
      this.$store.commit("updateLanguageOpen", true);
    },
    changeDashboard( type )
    {
      console.log('AAAA', type );
      this.$store.commit('updateDashboardType', type );
      this.$router.push({ path: ( type === 'admin' ? '/dashboardadmin' : '/dashboard' ) })
    },
    closeMenu()
    { 
      console.log('AAAA zatvarame');
      document.getElementById("nav-icon3").classList.remove("open");
      document.getElementById("nav-icon3").classList.add("colapsed");
      document.getElementById("ftco-nav").classList.remove("show");
    },
    menu()
    {   
      if( document.getElementById("nav-icon3").classList.contains('colapsed') )
      {
        document.getElementById("nav-icon3").classList.add("open");
        document.getElementById("nav-icon3").classList.remove("colapsed");
        
      }
      else
      {
        document.getElementById("nav-icon3").classList.remove("open");
        document.getElementById("nav-icon3").classList.add("colapsed");
      }
    },
    resized()
    {
      this.windowWidth = window.innerWidth;
    },
    seeIt( id )
    {
      if( !this.seened.includes( id ) ){ this.seened.push(id); }
      if( !this.seenedIDs.includes( id ) ){ this.seenedIDs.push(id); }

      if( this.seenedIDs.length )
      {
        setTimeout( () => {
          this.setSeened();
        }, 5000 );
      }
    },
    setSeened()
    {
    //console.log( 'SEEEEND THIS', this.seenedIDs ) ;
      axios.post( this.url2, { ids: this.seenedIDs }, {
        headers: this.headers,
      })
        .then(response => {
          this.seenedIDs = [];
        })
        .catch(error => {
          this.errors.push(error);
        })
    },
    toChallenge(route, id) {
      //console.log('editChallenge ' + id);
      if( id )
      {
        this.$store.commit('updateSelectedChID', id);
      }

      this.$router.push({ path: route })
    },
    reminder()
    {
      setTimeout( this.reminder, 10 * 1000 );
      if( this.isLogged )
      {
        //console.log( 'REMIND' );
        axios.get( this.url+'/'+this.getLang+'/i'+this.maxNotifyID, {
          headers: this.headers
        })
          .then(response => {

          /*
            this.tasks = 100;
            this.challenges = 10;
            this.reports = 1;
           */
            //console.log('REMINDER RESPONSE');
            //console.log(response.data);

            if( response.data.tasks ){ this.tasks = response.data.tasks; }else{ this.tasks = 0; }
            if( response.data.challenges ){ this.challenges = response.data.challenges; }else{ this.challenges = 0; }
            if( response.data.reports ){ this.reports = response.data.reports; }else{ this.reports = 0; }
            if( response.data.support ){ this.support = response.data.support.personal_data + response.data.support.payment; }else{ this.support = 0; }
            if( response.data.notifications ){

              let norRevAr = response.data.notifications.reverse();

              for( let i = 0; i < norRevAr.length; i++ )
              {
                if(!this.maxNotifyID || this.maxNotifyID < norRevAr[i].id ){ this.maxNotifyID = norRevAr[i].id; }

                if( !this.notiIDs.includes( norRevAr[i].id ) )
                {
                  this.notiIDs.push( norRevAr[i].id );
                  this.userNotes.push( norRevAr[i] );
                }
              }
            }

            this.refreshLangKey = Math.floor(Math.random() * 10000000000);
          })
          .catch(error => {
            this.errors.push(error);
          ////console.log(error);
          })
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    toggleSubmenu() {
      this.submenu = !this.submenu;
    },
    toggleSubmenuAdmin() {
      this.submenuAdmin = !this.submenuAdmin;
    },
    toggleMainMenu() {
      this.menu = !this.menu;
    },
    hideMainMenu() {
      this.menu = false;
    },
    toggleNotes(){
      this.showNotes = !this.showNotes;
    },
    logout() {
      this.$store.commit("updateUserLoggin", false);
      this.$store.commit('updateUserPrivileges', [] );
      this.accessToken = null;
      localStorage.removeItem("access");
      this.$router.push({ path: "/login" });
    },
    init() {
    //console.log(this.$route.path);
    }
  },
  components: {
    'open-language': Language
  }
};
</script>


<style>


.icondashboard{
  padding-right: 20px;
  transition: transform .4s;
}

.icondashboard:hover{
    -ms-transform: scale(1.05); /* IE 9 */
    -webkit-transform: scale(1.05); /* Safari 3-8 */
    transform: scale(1.05);  
  }

.dropdownhead-header {
  display: inline-block;
  position: relative;
}
.dropdownhead-content-header {

  display: none;
  position: absolute;
  width: auto;
  overflow: auto;
  border-radius: 14px;
  background-color: white;
  border: solid 1px #787878;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.1);


}
.dropdownhead-header:hover .dropdownhead-content-header {
  display: block;

}
.dropdownhead-header:hover .arrowaccount {
  transform: rotate(180deg);

}
.dropdownhead-content-header a {
  padding: 10px;
  display: block;
  color: #000000;
  font-size: 16px;
  font-family: 'LatoBold';
  text-decoration: none;

}

.dropdownhead-content-header a:hover {
  text-decoration: none;
  color: #000000;
  background-color:rgba(136, 136, 136, 0.2);

}

.companybox {

  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  border-bottom: solid 1px #787878;


}

.companyname {
  color: #000000;
  font-family: 'LatoBlack';
  font-size: 16px;
  margin: 0px;
}

.logo1 {
  height: 30px;
  width: auto;
  float: left;
  margin-top: 15px;
  margin-left: 0px;


}
.buttonlogin{
  width: auto;
  max-width:  none;
  height: 45px !important;
  display: flex;
  position: relative;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50px;
  border-color: none;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 3px;
  margin: 0px;
  margin-top: 0;
  
 }
 .buttonlogin .login{
 color: rgb(0, 0, 0);
 font-family: 'LatoMid';
 font-size: 18px;
 padding-left: 10px;
 padding-right: 10px;
 padding-bottom: 1px;
 width: auto;


}


.buttonheader-header-balance{
  width: auto;
  max-width:  none;
  height: 45px !important;
  display: flex;
  position: relative;
  align-items: center;
  background-color: black;
  border-radius: 50px;
  border-color: none;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 2px;
  padding-bottom: 3px;
  margin-right: 25px;
  border: 2px solid white;
 }
 .buttonheader-header-balance .account{
 color: white;
 font-family: 'LatoMid';
 font-size: 18px;
 padding-left: 10px;
 padding-bottom: 1px;
 width: auto;
}
.buttonheader-header-balance .icon{
  width: 28px;
  height: auto;
  margin-top: -2px;
}


.buttonheader-header{
  width: auto;
  max-width:  none;
  height: 45px !important;
  display: flex;
  position: relative;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50px;
  border-color: none;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  padding-bottom: 3px;
  
 }
 .buttonheader-header .account{
 color: rgb(0, 0, 0);
 font-family: 'LatoMid';
 font-size: 18px;
 padding-left: 10px;
 padding-right: 10px;
 padding-bottom: 1px;
 width: auto;
}
.buttonheader-header .icon{
  width: 20px;
  height: auto;
}

.buttonheader-header .arrowaccount{
width: 15px;
padding-left: 2px;
height: auto;

}

.buttoncreate{
width: 190px;
height: 45px !important;
display: flex;
position: relative;
align-items: center;
background: linear-gradient(90deg, rgba(12,124,213,1) 0%, rgba(0,188,212,1) 100%);
border-radius: 50px;
border-color: none;
padding-left: 10px;
padding-top: 2px;
padding-bottom: 3px;
padding-right: 15px;
margin-right: 25px;
}
.buttoncreate .create{
color: rgb(255, 255, 255);
font-family: 'LatoMid';
font-size: 18px;
padding-left: 10px;
width: auto;
padding-bottom: 1px;
}


.buttoncreate .icon{
width: 26px;
height: auto;
}


.buttondownload-active {
  opacity: 1;
  transition: all linear .2s;
}
.buttondownload-deactive {
  opacity: 0;
  transition: all linear .2s;
 } 



.buttondownload{
  width: 120px;
  height: 45px !important;
  display: flex;
  margin-top: 0px;
  margin-left: 0px;
  position: relative;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50px;
  border: 2px solid #000000;
  padding-left: 20px;
  padding-top: 2px;
  padding-bottom: 3px;
  padding-right: 20px;
}

  .buttondownload .download{
    color: rgb(0, 0, 0);
    font-family: 'LatoMid';
    font-size: 18px;
    padding-left: 10px;
    width: auto;
    padding-bottom: 1px;
    }


 .buttonadmin{
width: 100px;
height: 38px ;
display: flex;
position: relative;
align-items: center;
background-color: #000000;
border-radius: 50px;
border: 2px solid #FFFFFF;
padding-left: 10px;
padding-top: 2px;
padding-bottom: 3px;
margin-left: 25px;
z-index: 2;

}
.buttonadmin .admin{
color: rgb(255, 255, 255);
font-family: 'LatoMid';
font-size: 18px;
padding-left: 10px;
width: auto;
padding-bottom: 1px;
}
.buttonadmin .arrowadmin{
width: 20px;
padding-left: 2px;
height: auto;


}
.buttonadmin-content {
  display: none;
  position: absolute;
  background-color: #000000;
  color: white;
  padding: 12px 16px;
  top: 46px;
  width: 80px;
  height: 40px;
  border-radius: 20px;
  border: 2px solid #FFFFFF;
  left: 0;
  z-index: 1;
  transition: width 600ms ease-out, height 600ms ease-out;

}
.buttonadmin:hover 
.buttonadmin-content {
  display: block;
  width: 80px;
  height: auto;

}
.admintext{
cursor: pointer;
font-family: 'LatoMid';
font-size: 17px;
line-height: 30px;
color: gray;
padding-left: 0px;
padding-top: 10px;
padding-bottom: 10px;

}
.admintext:hover{
  color: white;
  }



.language-img{
  width: 20px;
  display: block; 

}
.drop-down-body
{
  visibility: visible;
  position: relative;
  margin-top: 0px;
  margin-left: 10px;
  margin-right: 0px;
  align-items: right;
  width: 60px;

}
.drop-down-btn {

  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-top: 4px;
  padding-bottom: 5px;
  padding-right: 5px;
  height: 25px;  
  width: 50px;   
  background-color: black;
  border-radius: 6px;
  color: rgb(255, 255, 255);
  cursor: pointer;
  text-decoration: none;

}
.language-menu{
   position: absolute;
   align-items: center;
   padding-left: 0px;
   padding-top: 0;
   margin-top: 0px;
   width: 65px;
   background-color: black;
   border-radius: 6px;
   opacity: 0;
   visibility: hidden;
   transition: opacity 0.4s, visibility 0.4s;
}

.language-item{
  display: flex;
  padding-top: 0px;
  padding-right: 5px;
  padding-left: 10px;
  padding-bottom: 0px;
  border-radius: 6px;
  align-items: center;    
  cursor: pointer;
  transition: background-color 0.4s;
}
.language-title{

  padding-left: 0px;
  width: 35px;
  margin-top: 6px;
  margin-bottom: 6px;
  padding-top: 4px;
  padding-bottom: 4px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
  font-family: 'LatoMid';
  color: white;
  text-decoration: none;
 }



.drop-down-btn:hover + .language-menu, 
.language-menu:hover{
  opacity: 1;
  visibility: visible;
}

.language-item:hover{
  border-radius: 6px;
  background-color: darkgrey;
}




@media (min-width: 306px) {

  .drop
  {
   display: none;
  }

  .drop-down-body{
  visibility: hidden;

  position: relative;
  margin-top: 0px;
  margin-left: auto;
  align-items: center;
  width: 70px;
  margin-right: auto;
}
   #nav-icon3 {
    width: 50px;
    position: relative;
    scale: 70%;
    height: 40px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
  }
  
#nav-icon3 span {
    display: block;
    position: absolute;
    height: 4px;
    width: 100%;
    background: #ffffff;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
  }
  #nav-icon3 span:nth-child(1) {
    top: 0px;
  }
  
  #nav-icon3 span:nth-child(2),#nav-icon3 span:nth-child(3) {
    top: 18px;
  }
  
  #nav-icon3 span:nth-child(4) {
    top: 36px;
  }
  
  #nav-icon3.open span:nth-child(1) {
    top: 18px;
    width: 0%;
    left: 50%;
  }
  
  #nav-icon3.open span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  
  #nav-icon3.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  
  #nav-icon3.open span:nth-child(4) {
    top: 18px;
    width: 0%;
    left: 50%;
  }


.logo1 {
  height: 30px;
  width: auto;
  align-items:center ;
  margin-top: 0px;
  margin-left: 30px;

}


.buttonlogin{
  max-width: 90px;
  align-items: center;
  margin: auto;
  margin-top: 20px;
  
 }
 .buttonlogin .login{
 color: rgb(0, 0, 0);
 font-family: 'LatoMid';
 font-size: 18px;
 padding-left: 10px;
 padding-right: 10px;
 padding-bottom: 1px;
 width: auto;

}
  .buttoncreate {
    align-items: center;
    margin: auto;
  }
  .buttonheader-header {
    align-items: center;
  max-width:  none;
    margin: auto;
    max-width: 120px;
    margin-top: 20px;
    margin-bottom: 20px;
  } 
  .buttondownload{
    width: 90px;
    height: 43px !important;
    display: flex;
    margin-top: 0px;
    float: right;
    position: relative;
    align-items: center;
    background-color: #ffffff;
    border: 2px solid #000000;
    border-radius: 50px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 2px;
    padding-bottom: 3px;
    display: flex;
    
  }
  
    .buttondownload .download{
      display: block;
      color: rgb(0, 0, 0);
      font-family: 'LatoBold';
      font-size: 15px;
      padding-left: 0px;
      width: auto;
      padding-bottom: 1px;
  
      }
 }

@media (min-width: 576px) {
  .buttoncreate {
    align-items: center;
    margin: auto;
  
  } }


@media (min-width: 768px) {
  .drop
  {
   display: none;
  }
  .drop-down-body
{

  position: relative;
  margin-top: 0px;
  margin-left: auto;
  align-items: center;
  width: 70px;
  margin-right: auto;
}
   #nav-icon3 {
    width: 40px;
    position: relative;

    height: 40px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
  }
  
#nav-icon3 span {
    display: block;
    position: absolute;
    height: 4px;
    width: 100%;
    background: #ffffff;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
  }
  #nav-icon3 span:nth-child(1) {
    top: 0px;
  }
  
  #nav-icon3 span:nth-child(2),#nav-icon3 span:nth-child(3) {
    top: 18px;
  }
  
  #nav-icon3 span:nth-child(4) {
    top: 36px;
  }
  
  #nav-icon3.open span:nth-child(1) {
    top: 18px;
    width: 0%;
    left: 50%;
  }
  
  #nav-icon3.open span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  
  #nav-icon3.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  
  #nav-icon3.open span:nth-child(4) {
    top: 18px;
    width: 0%;
    left: 50%;
  }


.logo1 {
  height: 30px;
  width: auto;
  align-items:center ;
  margin-top: 0px;
  margin-left: 55px;

}

  .buttoncreate {
    align-items: center;
    margin: auto;
  }
  .buttonheader-header {
    align-items: center;
  max-width:  none;
    margin: auto;
    max-width: 120px;
    margin-top: 20px;
    margin-bottom: 20px;
  } 
  .buttondownload{
    width: 90px;
    height: 43px !important;
    display: flex;
    margin-top: 0px;
    float: right;
    position: relative;
    align-items: center;
    background-color: #ffffff;
    border: 2px solid #000000;
    border-radius: 50px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 2px;
    padding-bottom: 3px;
    display: flex;
    
  }
  
    .buttondownload .download{
      color: rgb(0, 0, 0);
      font-family: 'LatoBold';
      font-size: 15px;
      padding-left: 0px;
      width: auto;
      padding-bottom: 1px;
  
      }
 }


 @media (min-width: 990px){

 
 
}


   @media (min-width: 991px){

    #nav-icon3 {
    display: none;
      }
        
    .logo1 {
      height: 25px;
      width: auto;
      float: left;
      margin-top: 0px;
      margin-left: 0px;
    
    }
    
      .buttoncreate{
        width: auto;
        height: 40px !important;
        display: flex;
        position: relative;
        align-items: center;
        background: linear-gradient(90deg, rgba(12,124,213,1) 0%, rgba(0,188,212,1) 100%);
        border-radius: 50px;
        border-color: none;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 2px;
        padding-bottom: 3px;
        margin-right: 25px;
        margin-left: 0px;
        margin-bottom: 0px;
        margin-top: 0px;
        }
        .buttoncreate .create{
        color: rgb(255, 255, 255);
        font-family: 'LatoMid';
        font-size: 15px;
        padding-left: 10px;
        width: auto;
        padding-bottom: 1px;
        }
        .buttoncreate .icon{
        width: 26px;
        height: auto;
        }
        .buttonheader-header{
          width: auto;
          max-width:  none;
          height: 40px !important;
          display: flex;
          margin-top: 0px;
          margin-left: 0px;
          margin-bottom: 0px;
          margin-right: 0px;
          position: relative;
          align-items: center;
          background-color: #ffffff;
          border-radius: 50px;
          border-color: none;
          padding-left: 20px;
          padding-right: 20px;   
          padding-top: 2px;
          padding-bottom: 3px;
          
         }
         .buttonheader-header .account{
         color: rgb(0, 0, 0);
         font-family: 'LatoMid';
         font-size: 15px;
         padding-left: 10px;
         padding-bottom: 1px;
         width: auto;
        }
        .buttonheader-header .icon{
          width: 20px;
          height: auto;
        }
        .buttondownload{
          display: none;
          width: 120px;
          height: 40px !important;
          margin-top: 0px;
          margin-left: 0px;
          position: relative;
          align-items: center;
          background-color: #000000;
          border-radius: 50px;
          padding-left: 10px;
          padding-right: 10px;
          padding-top: 2px;
          padding-bottom: 3px;
          
        }
        
          .buttondownload .download{

            color: rgb(255, 255, 255);
            font-family: 'LatoBold';
            font-size: 18px;
            padding-left: 10px;
            width: auto;
            padding-bottom: 1px;
            }
        
            .drop-down-body
            {
              position: relative;
              margin-top: 0px;
              width: 60px;
              margin-left: 10px;
              margin-right: 0px;
              align-items: right;
            
     
}
.buttonlogin{
  width: auto;
  max-width:  none;
  height: 40px !important;
  display: flex;
  position: relative;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50px;
  border-color: none;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 3px;
  margin: 0;
  margin-top: 0px;

  
 }
 .buttonlogin .login{
 color: rgb(0, 0, 0);
 font-family: 'LatoMid';
 font-size: 15px;
 padding-left: 10px;
 padding-right: 10px;
 padding-bottom: 1px;
 width: auto;

}
  .drop-down-body
        {
          visibility: visible;
          position: relative;
          margin-top: 0px;
          width: 60px;
          margin-left: 10px;
          margin-right: 0px;
          align-items: right;




  }
}

@media (min-width: 1200px) {

  #nav-icon3 {
  display: none;
  }
  

.logo1 {
  height: 30px;
  width: auto;
  float: left;
  margin-top: 0px;
  margin-left: 0px;

}

  .buttoncreate{
    width: auto;
    height: 45px !important;
    display: flex;
    position: relative;
    align-items: center;
    background: linear-gradient(90deg, rgba(12,124,213,1) 0%, rgba(0,188,212,1) 100%);
    border-radius: 50px;
    border-color: none;
    padding-left: 10px;
    padding-right: 15px;
    padding-top: 2px;
    padding-bottom: 3px;
    margin-right: 25px;
    margin-left: 0px;
    margin-bottom: 0px;
    margin-top: 0px;
    }
    .buttoncreate .create{
    color: rgb(255, 255, 255);
    font-family: 'LatoMid';
    font-size: 18px;
    padding-left: 10px;
    width: auto;
    padding-bottom: 1px;
    }
    .buttoncreate .icon{
    width: 26px;
    height: auto;
    }
    .buttonheader-header{
      width: auto;
      max-width:  none;
      height: 45px !important;
      display: flex;
      margin-top: 0px;
      margin-left: 0px;
      margin-bottom: 0px;
      margin-right: 0px;
      position: relative;
      align-items: center;
      background-color: #ffffff;
      border-radius: 50px;
      border-color: none;
      padding-left: 20px;
      padding-top: 2px;
      padding-bottom: 3px;
      
     }
     .buttonheader-header .account{
     color: rgb(0, 0, 0);
     font-family: 'LatoMid';
     font-size: 18px;
     padding-left: 10px;
     padding-bottom: 1px;
     width: auto;
    }
    .buttonheader-header .icon{
      width: 20px;
      height: auto;
    }
    .buttondownload{
      display: none;
      width: 120px;
      height: 45px !important;

      margin-top: 0px;
      margin-left: 0px;
      position: relative;
      align-items: center;
      background-color: #000000;
      border-radius: 50px;
      padding-left: 20px;
      padding-top: 2px;
      padding-bottom: 3px;
      
    }
    
      .buttondownload .download{
        display: none;
        color: rgb(255, 255, 255);
        font-family: 'LatoMid';
        font-size: 18px;
        padding-left: 10px;
        width: auto;
        padding-bottom: 1px;
        }
    
        .drop-down-body
        {
          visibility: visible;
          position: relative;
          margin-top: 0px;
          width: 60px;
          margin-left: 10px;
          margin-right: 0px;
          align-items: right;

}
.buttonlogin{
  width: auto;
  max-width:  none;
  height: 45px !important;
  display: flex;
  position: relative;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50px;
  border-color: none;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 3px;
  margin: 0;
  margin-top: 0px;

  
 }
 .buttonlogin .login{
 color: rgb(0, 0, 0);
 font-family: 'LatoMid';
 font-size: 18px;
 padding-left: 10px;
 padding-right: 10px;
 padding-bottom: 1px;
 width: auto;

        
 }

}





.container1 {
    width: 100%;
    margin-right: 0px;
    margin-left: 0px; }
    @media (min-width: 576px) {
      .container1 {
           } }
    @media (min-width: 768px) {
      .container1 {
     } }
    @media (min-width: 992px) {
      .container1 {
       } }
    @media (min-width: 1200px) {
      .container1 {
     } }
  

   .navbarPX {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 0.5rem 1rem; }
    .navbarPX > .container1,
    .navbarPX > .container1-fluid {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between; }

      @media (max-width: 575.98px) {
        .navbarPX-expand-sm > .container1,
        .navbarPX-expand-sm > .container1-fluid {
          padding-right: 0;
          padding-left: 0; } }
      
      @media (min-width: 576px) {
        .navbarPX-expand-sm {
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -ms-flex-flow: row nowrap;
          flex-flow: row nowrap;
          -webkit-box-pack: start;
          -ms-flex-pack: start;
          justify-content: flex-start; }
          .navbarPX-expand-sm .navbarPX-nav {
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row; }
            .navbarPX-expand-sm .navbarPX-nav .dropdownPX-menu {
              position: absolute; }
            .navbarPX-expand-sm .navbarPX-nav .nav-linkPX {
              padding-right: 0.5rem;
              padding-left: 0.5rem; }
          .navbarPX-expand-sm > .container1,
          .navbarPX-expand-sm > .container1-fluid {
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap; }
          .navbarPX-expand-sm .navbarPX-collapse {
            display: -webkit-box !important;
            display: -ms-flexbox !important;
            display: flex !important;
            -ms-flex-preferred-size: auto;
            flex-basis: auto; }
          .navbarPX-expand-sm .navbarPX-toggler {
            display: none; } }
      
      @media (max-width: 767.98px) {
        .navbarPX-expand-md > .container1,
        .navbarPX-expand-md > .container1-fluid {
          padding-right: 0;
          padding-left: 0; } }
      
      @media (min-width: 768px) {
        .navbarPX-expand-md {
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -ms-flex-flow: row nowrap;
          flex-flow: row nowrap;
          -webkit-box-pack: start;
          -ms-flex-pack: start;
          justify-content: flex-start; }
          .navbarPX-expand-md .navbarPX-nav {
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row; }
            .navbarPX-expand-md .navbarPX-nav .dropdownPX-menu {
              position: absolute; }
            .navbarPX-expand-md .navbarPX-nav .nav-linkPX {
              padding-right: 0.5rem;
              padding-left: 0.5rem; }
          .navbarPX-expand-md > .container1,
          .navbarPX-expand-md > .container1-fluid {
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap; }
          .navbarPX-expand-md .navbarPX-collapse {
            display: -webkit-box !important;
            display: -ms-flexbox !important;
            display: flex !important;
            -ms-flex-preferred-size: auto;
            flex-basis: auto; }
          .navbarPX-expand-md .navbarPX-toggler {
            display: none; } }
      
      @media (max-width: 991.98px) {
        .navbarPX-expand-lg > .container1,
        .navbarPX-expand-lg > .container1-fluid {
          padding-right: 0;
          padding-left: 0; } }
      
      @media (min-width: 992px) {
        .navbarPX-expand-lg {
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -ms-flex-flow: row nowrap;
          flex-flow: row nowrap;
          -webkit-box-pack: start;
          -ms-flex-pack: start;
          justify-content: flex-start; }
          .navbarPX-expand-lg .navbarPX-nav {
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row; }
            .navbarPX-expand-lg .navbarPX-nav .dropdownPX-menu {
              position: absolute; }
            .navbarPX-expand-lg .navbarPX-nav .nav-linkPX {
              padding-right: 0.5rem;
              padding-left: 0.5rem; }
          .navbarPX-expand-lg > .container1,
          .navbarPX-expand-lg > .container1-fluid {
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap; }
          .navbarPX-expand-lg .navbarPX-collapse {
            display: -webkit-box !important;
            display: -ms-flexbox !important;
            display: flex !important;
            -ms-flex-preferred-size: auto;
            flex-basis: auto; }
          .navbarPX-expand-lg .navbarPX-toggler {
            display: none; } }
      
      @media (max-width: 1199.98px) {
        .navbarPX-expand-xl > .container1,
        .navbarPX-expand-xl > .container1-fluid {
          padding-right: 0;
          padding-left: 0; } }
      
      @media (min-width: 1200px) {
        .navbarPX-expand-xl {
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -ms-flex-flow: row nowrap;
          flex-flow: row nowrap;
          -webkit-box-pack: start;
          -ms-flex-pack: start;
          justify-content: flex-start; }
          .navbarPX-expand-xl .navbarPX-nav {
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row; }
            .navbarPX-expand-xl .navbarPX-nav .dropdownPX-menu {
              position: absolute; }
            .navbarPX-expand-xl .navbarPX-nav .nav-linkPX {
              padding-right: 0.5rem;
              padding-left: 0.5rem; }
          .navbarPX-expand-xl > .container1,
          .navbarPX-expand-xl > .container1-fluid {
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap; }
          .navbarPX-expand-xl .navbarPX-collapse {
            display: -webkit-box !important;
            display: -ms-flexbox !important;
            display: flex !important;
            -ms-flex-preferred-size: auto;
            flex-basis: auto; }
          .navbarPX-expand-xl .navbarPX-toggler {
            display: none; } }
      
      .navbarPX-expand {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start; }
        .navbarPX-expand > .container1,
        .navbarPX-expand > .container1-fluid {
          padding-right: 0;
          padding-left: 0; }
        .navbarPX-expand .navbarPX-nav {
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -ms-flex-direction: row;
          flex-direction: row; }
          .navbarPX-expand .navbarPX-nav .dropdownPX-menu {
            position: absolute; }
          .navbarPX-expand .navbarPX-nav .nav-linkPX {
            padding-right: 0.5rem;
            padding-left: 0.5rem; }
        .navbarPX-expand > .container1,
        .navbarPX-expand > .container1-fluid {
          -ms-flex-wrap: nowrap;
          flex-wrap: nowrap; }
        .navbarPX-expand .navbarPX-collapse {
          display: -webkit-box !important;
          display: -ms-flexbox !important;
          display: flex !important;
          -ms-flex-preferred-size: auto;
          flex-basis: auto; }
        .navbarPX-expand .navbarPX-toggler {
          display: none; }

          .ftco-navbarPX-light {
            background: rgb(0, 0, 0) !important;
            z-index: 3;
            padding-left: 35px;
            padding-top: 4px;
            padding-bottom: 4px;
            padding-right: 35px;
            -webkit-box-shadow: 0px 5px 20px -17px rgba(0, 0, 0, 0.34);
            -moz-box-shadow: 0px 5px 20px -17px rgba(0, 0, 0, 0.34);
            box-shadow: 0px 5px 20px -17px rgba(0, 0, 0, 0.34); }
            @media (max-width: 991.98px) {
              .ftco-navbarPX-light {
                background: #000 !important;
                position: relative;
                top: 0;
                padding: 10px 15px; } }
            .ftco-navbarPX-light .navbarPX-brand {
              color: #000;
              text-transform: uppercase;
              font-weight: 700; }
              .ftco-navbarPX-light .navbarPX-brand:hover, .ftco-navbarPX-light .navbarPX-brand:focus {
                color: #000; }
              @media (max-width: 991.98px) {
                .ftco-navbarPX-light .navbarPX-brand {
                  color: #fff; } }
            @media (max-width: 991.98px) {
              .ftco-navbarPX-light .navbarPX-nav {
                padding-bottom: 500px; 
                padding-top: 30px;
                width: auto;
                min-width: 300px;
                align-items: center;
                margin: auto;
              } }
            
            .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX > .nav-linkPX {
              font-size: 17px;
              padding-top: 1.2rem;
              padding-bottom: 1.2rem;
              padding-left: 15px;
              padding-right: 15px;
              font-family: 'LatoMid';
              color: #ffffff;
              position: relative;
              letter-spacing: normal;
                           opacity: 1 !important; 
            }
              .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX > .nav-linkPX:hover {
                color: #757575; }


              @media (max-width: 1115px) {
                .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX > .nav-linkPX {
              font-size: 13px;
              padding-top: 1.2rem;
              padding-bottom: 1.2rem;
              padding-left: 15px;
              padding-right: 15px;
              font-family: 'LatoMid';
              color: #ffffff;
              position: relative;
              letter-spacing: normal;
              opacity: 1 !important; 
                
                }
                  .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX > .nav-linkPX:hover {
                    color: #757575; } }


                    @media (max-width: 992px) {
                      .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX > .nav-linkPX {
                    font-size: 20px;
                    padding-top: 1.2rem;
                    padding-bottom: 1.2rem;
                    padding-left: 15px;
                    padding-right: 15px;
                    font-family: 'LatoMid';
                    color: #ffffff;
                    position: relative;
                    letter-spacing: 0px;                 
                    opacity: 1 !important; 
                      
                      }
                        .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX > .nav-linkPX:hover {
                          color: #757575; } }


                          

              .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX > .nav-linkPX.icon-cart {
                border: 1px solid #fec771;
                width: 40px;
                height: 40px;
                border-radius: 50%; }
                .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX > .nav-linkPX.icon-cart .fa {
                  color: #fec771; }
            .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX .dropdownPX-menu {
              border: none;
              background: #fff;
              -webkit-box-shadow: 0px 10px 34px -20px rgba(0, 0, 0, 0.41);
              -moz-box-shadow: 0px 10px 34px -20px rgba(0, 0, 0, 0.41);
              box-shadow: 0px 10px 34px -20px rgba(0, 0, 0, 0.41);
              border-radius: 4px;
              padding: 0; }
              .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX .dropdownPX-menu .dropdownPX-item {
                font-size: 12px;
                color: #000; }
                .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX .dropdownPX-menu .dropdownPX-item:hover, .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX .dropdownPX-menu .dropdownPX-item:focus {
                  background: #ffffff;
                  color: #fff; }
            .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX.cta > a {
              color: #fff;
              background: #ffffff;
              border-radius: 0px; }
              @media (max-width: 767.98px) {
                .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX.cta > a {
                  padding-left: 15px;
                  padding-right: 15px; } }
              @media (max-width: 991.98px) {
                .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX.cta > a {
                  color: #fff;
                  background: #ffffff;
                  border-radius: 4px; } }
            .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX.active > a {
              color: #ffffff; }
              @media (max-width: 991.98px) {
                .ftco-navbarPX-light .navbarPX-nav > .nav-itemPX.active > a {
                  color: #fff; } }
            .ftco-navbarPX-light .navbarPX-toggler {
              border: none;
              color: rgba(255, 255, 255, 0.5) !important;
              cursor: pointer;
              padding-right: 0;
              text-transform: uppercase;
              font-size: 16px;
              letter-spacing: .1em; }
              .ftco-navbarPX-light .navbarPX-toggler:focus {
                outline: none !important; }

 .navbarPX-brand {
                    display: inline-block;
                    padding-top: 0.3125rem;
                    padding-bottom: 0.3125rem;
                    margin-right: 1rem;
                    font-size: 1.25rem;
                    line-height: inherit;
                    white-space: nowrap; }
                    .navbarPX-brand:hover, .navbarPX-brand:focus {
                      text-decoration: none; }

   .navbarPX-toggler {
                        padding: 0.25rem 0.75rem;
                        font-size: 1.25rem;
                        line-height: 1;
                        background-color: transparent;
                        border: 1px solid transparent;
                        border-radius: 0.25rem; }

    .navbarPX-toggler:hover, .navbarPX-toggler:focus {
    text-decoration: none; }
                                                        

.navbarPX-collapse {
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center; }
  

.collapse:not(.show) {
    display: none; }

    .navbarPX-nav {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
        margin-top: 0px;
      
      
      }
        
        .navbarPX-nav .nav-linkPX {
          padding-right: 0;
          padding-left: 0; }
        .navbarPX-nav .dropdownPX-menu {
          position: static;
          float: none; }

          .m-0 {
            margin: 0 !important; }
          
          .mt-0,
          .my-0 {
            margin-top: 0 !important; }
          
          .mr-0,
          .mx-0 {
            margin-right: 0 !important; }
          
          .mb-0,
          .my-0 {
            margin-bottom: 0 !important; }
          
          .ml-0,
          .mx-0 {
            margin-left: 0 !important; }
          
          .m-1 {
            margin: 0.25rem !important; }
          
          .mt-1,
          .my-1 {
            margin-top: 0.25rem !important; }
          
          .mr-1,
          .mx-1 {
            margin-right: 0.25rem !important; }
          
          .mb-1,
          .my-1 {
            margin-bottom: 0.25rem !important; }
          
          .ml-1,
          .mx-1 {
            margin-left: 0.25rem !important; }
          
          .m-2 {
            margin: 0.5rem !important; }
          
          .mt-2,
          .my-2 {
            margin-top: 0.5rem !important; }
          
          .mr-2,
          .mx-2 {
            margin-right: 0.5rem !important; }
          
          .mb-2,
          .my-2 {
            margin-bottom: 0.5rem !important; }
          
          .ml-2,
          .mx-2 {
            margin-left: 0.5rem !important; }
          
          .m-3 {
            margin: 1rem !important; }
          
          .mt-3,
          .my-3 {
            margin-top: 1rem !important; }
          
          .mr-3,
          .mx-3 {
            margin-right: 1rem !important; }
          
          .mb-3,
          .my-3 {
            margin-bottom: 1rem !important; }
          
          .ml-3,
          .mx-3 {
            margin-left: 1rem !important; }
          
          .m-4 {
            margin: 1.5rem !important; }
          
          .mt-4,
          .my-4 {
            margin-top: 1.5rem !important; }
          
          .mr-4,
          .mx-4 {
            margin-right: 1.5rem !important; }
          
          .mb-4,
          .my-4 {
            margin-bottom: 1.5rem !important; }
          
          .ml-4,
          .mx-4 {
            margin-left: 1.5rem !important; }
          
          .m-5 {
            margin: 3rem !important; }
          
          .mt-5,
          .my-5 {
            margin-top: 3rem !important; }
          
          .mr-5,
          .mx-5 {
            margin-right: 3rem !important; }
          
          .mb-5,
          .my-5 {
            margin-bottom: 3rem !important; }
          
          .ml-5,
          .mx-5 {
            margin-left: 3rem !important; }
          
          .p-0 {
            padding: 0 !important; }
          
          .pt-0,
          .py-0 {
            padding-top: 0 !important; }
          
          .pr-0,
          .px-0 {
            padding-right: 0 !important; }
          
          .pb-0,
          .py-0 {
            padding-bottom: 0 !important; }
          
          .pl-0,
          .px-0 {
            padding-left: 0 !important; }
          
          .p-1 {
            padding: 0.25rem !important; }
          
          .pt-1,
          .py-1 {
            padding-top: 0.25rem !important; }
          
          .pr-1,
          .px-1 {
            padding-right: 0.25rem !important; }
          
          .pb-1,
          .py-1 {
            padding-bottom: 0.25rem !important; }
          
          .pl-1,
          .px-1 {
            padding-left: 0.25rem !important; }
          
          .p-2 {
            padding: 0.5rem !important; }
          
          .pt-2,
          .py-2 {
            padding-top: 0.5rem !important; }
          
          .pr-2,
          .px-2 {
            padding-right: 0.5rem !important; }
          
          .pb-2,
          .py-2 {
            padding-bottom: 0.5rem !important; }
          
          .pl-2,
          .px-2 {
            padding-left: 0.5rem !important; }
          
          .p-3 {
            padding: 1rem !important; }
          
          .pt-3,
          .py-3 {
            padding-top: 1rem !important; }
          
          .pr-3,
          .px-3 {
            padding-right: 1rem !important; }
          
          .pb-3,
          .py-3 {
            padding-bottom: 1rem !important; }
          
          .pl-3,
          .px-3 {
            padding-left: 1rem !important; }
          
          .p-4 {
            padding: 1.5rem !important; }
          
          .pt-4,
          .py-4 {
            padding-top: 1.5rem !important; }
          
          .pr-4,
          .px-4 {
            padding-right: 1.5rem !important; }
          
          .pb-4,
          .py-4 {
            padding-bottom: 1.5rem !important; }
          
          .pl-4,
          .px-4 {
            padding-left: 1.5rem !important; }
          
          .p-5 {
            padding: 3rem !important; }
          
          .pt-5,
          .py-5 {
            padding-top: 3rem !important; }
          
          .pr-5,
          .px-5 {
            padding-right: 3rem !important; }
          
          .pb-5,
          .py-5 {
            padding-bottom: 3rem !important; }
          
          .pl-5,
          .px-5 {
            padding-left: 3rem !important; }
          
          .m-n1 {
            margin: -0.25rem !important; }
          
          .mt-n1,
          .my-n1 {
            margin-top: -0.25rem !important; }
          
          .mr-n1,
          .mx-n1 {
            margin-right: -0.25rem !important; }
          
          .mb-n1,
          .my-n1 {
            margin-bottom: -0.25rem !important; }
          
          .ml-n1,
          .mx-n1 {
            margin-left: -0.25rem !important; }
          
          .m-n2 {
            margin: -0.5rem !important; }
          
          .mt-n2,
          .my-n2 {
            margin-top: -0.5rem !important; }
          
          .mr-n2,
          .mx-n2 {
            margin-right: -0.5rem !important; }
          
          .mb-n2,
          .my-n2 {
            margin-bottom: -0.5rem !important; }
          
          .ml-n2,
          .mx-n2 {
            margin-left: -0.5rem !important; }
          
          .m-n3 {
            margin: -1rem !important; }
          
          .mt-n3,
          .my-n3 {
            margin-top: -1rem !important; }
          
          .mr-n3,
          .mx-n3 {
            margin-right: -1rem !important; }
          
          .mb-n3,
          .my-n3 {
            margin-bottom: -1rem !important; }
          
          .ml-n3,
          .mx-n3 {
            margin-left: -1rem !important; }
          
          .m-n4 {
            margin: -1.5rem !important; }
          
          .mt-n4,
          .my-n4 {
            margin-top: -1.5rem !important; }
          
          .mr-n4,
          .mx-n4 {
            margin-right: -1.5rem !important; }
          
          .mb-n4,
          .my-n4 {
            margin-bottom: -1.5rem !important; }
          
          .ml-n4,
          .mx-n4 {
            margin-left: -1.5rem !important; }
          
          .m-n5 {
            margin: -3rem !important; }
          
          .mt-n5,
          .my-n5 {
            margin-top: -3rem !important; }
          
          .mr-n5,
          .mx-n5 {
            margin-right: -3rem !important; }
          
          .mb-n5,
          .my-n5 {
            margin-bottom: -3rem !important; }
          
          .ml-n5,
          .mx-n5 {
            margin-left: -3rem !important; }
          
          .m-auto {
            margin: auto !important; }
          
          .mt-auto,
          .my-auto {
            margin-top: auto !important; }
          
          .mr-auto,
          .mx-auto {
            margin-right: auto !important; }
          
          .mb-auto,
          .my-auto {
            margin-bottom: auto !important; }
          
          .ml-auto,
          .mx-auto {
            margin-left: auto !important; }
          
          @media (min-width: 576px) {
            .m-sm-0 {
              margin: 0 !important; }
            .mt-sm-0,
            .my-sm-0 {
              margin-top: 0 !important; }
            .mr-sm-0,
            .mx-sm-0 {
              margin-right: 0 !important; }
            .mb-sm-0,
            .my-sm-0 {
              margin-bottom: 0 !important; }
            .ml-sm-0,
            .mx-sm-0 {
              margin-left: 0 !important; }
            .m-sm-1 {
              margin: 0.25rem !important; }
            .mt-sm-1,
            .my-sm-1 {
              margin-top: 0.25rem !important; }
            .mr-sm-1,
            .mx-sm-1 {
              margin-right: 0.25rem !important; }
            .mb-sm-1,
            .my-sm-1 {
              margin-bottom: 0.25rem !important; }
            .ml-sm-1,
            .mx-sm-1 {
              margin-left: 0.25rem !important; }
            .m-sm-2 {
              margin: 0.5rem !important; }
            .mt-sm-2,
            .my-sm-2 {
              margin-top: 0.5rem !important; }
            .mr-sm-2,
            .mx-sm-2 {
              margin-right: 0.5rem !important; }
            .mb-sm-2,
            .my-sm-2 {
              margin-bottom: 0.5rem !important; }
            .ml-sm-2,
            .mx-sm-2 {
              margin-left: 0.5rem !important; }
            .m-sm-3 {
              margin: 1rem !important; }
            .mt-sm-3,
            .my-sm-3 {
              margin-top: 1rem !important; }
            .mr-sm-3,
            .mx-sm-3 {
              margin-right: 1rem !important; }
            .mb-sm-3,
            .my-sm-3 {
              margin-bottom: 1rem !important; }
            .ml-sm-3,
            .mx-sm-3 {
              margin-left: 1rem !important; }
            .m-sm-4 {
              margin: 1.5rem !important; }
            .mt-sm-4,
            .my-sm-4 {
              margin-top: 1.5rem !important; }
            .mr-sm-4,
            .mx-sm-4 {
              margin-right: 1.5rem !important; }
            .mb-sm-4,
            .my-sm-4 {
              margin-bottom: 1.5rem !important; }
            .ml-sm-4,
            .mx-sm-4 {
              margin-left: 1.5rem !important; }
            .m-sm-5 {
              margin: 3rem !important; }
            .mt-sm-5,
            .my-sm-5 {
              margin-top: 3rem !important; }
            .mr-sm-5,
            .mx-sm-5 {
              margin-right: 3rem !important; }
            .mb-sm-5,
            .my-sm-5 {
              margin-bottom: 3rem !important; }
            .ml-sm-5,
            .mx-sm-5 {
              margin-left: 3rem !important; }
            .p-sm-0 {
              padding: 0 !important; }
            .pt-sm-0,
            .py-sm-0 {
              padding-top: 0 !important; }
            .pr-sm-0,
            .px-sm-0 {
              padding-right: 0 !important; }
            .pb-sm-0,
            .py-sm-0 {
              padding-bottom: 0 !important; }
            .pl-sm-0,
            .px-sm-0 {
              padding-left: 0 !important; }
            .p-sm-1 {
              padding: 0.25rem !important; }
            .pt-sm-1,
            .py-sm-1 {
              padding-top: 0.25rem !important; }
            .pr-sm-1,
            .px-sm-1 {
              padding-right: 0.25rem !important; }
            .pb-sm-1,
            .py-sm-1 {
              padding-bottom: 0.25rem !important; }
            .pl-sm-1,
            .px-sm-1 {
              padding-left: 0.25rem !important; }
            .p-sm-2 {
              padding: 0.5rem !important; }
            .pt-sm-2,
            .py-sm-2 {
              padding-top: 0.5rem !important; }
            .pr-sm-2,
            .px-sm-2 {
              padding-right: 0.5rem !important; }
            .pb-sm-2,
            .py-sm-2 {
              padding-bottom: 0.5rem !important; }
            .pl-sm-2,
            .px-sm-2 {
              padding-left: 0.5rem !important; }
            .p-sm-3 {
              padding: 1rem !important; }
            .pt-sm-3,
            .py-sm-3 {
              padding-top: 1rem !important; }
            .pr-sm-3,
            .px-sm-3 {
              padding-right: 1rem !important; }
            .pb-sm-3,
            .py-sm-3 {
              padding-bottom: 1rem !important; }
            .pl-sm-3,
            .px-sm-3 {
              padding-left: 1rem !important; }
            .p-sm-4 {
              padding: 1.5rem !important; }
            .pt-sm-4,
            .py-sm-4 {
              padding-top: 1.5rem !important; }
            .pr-sm-4,
            .px-sm-4 {
              padding-right: 1.5rem !important; }
            .pb-sm-4,
            .py-sm-4 {
              padding-bottom: 1.5rem !important; }
            .pl-sm-4,
            .px-sm-4 {
              padding-left: 1.5rem !important; }
            .p-sm-5 {
              padding: 3rem !important; }
            .pt-sm-5,
            .py-sm-5 {
              padding-top: 3rem !important; }
            .pr-sm-5,
            .px-sm-5 {
              padding-right: 3rem !important; }
            .pb-sm-5,
            .py-sm-5 {
              padding-bottom: 3rem !important; }
            .pl-sm-5,
            .px-sm-5 {
              padding-left: 3rem !important; }
            .m-sm-n1 {
              margin: -0.25rem !important; }
            .mt-sm-n1,
            .my-sm-n1 {
              margin-top: -0.25rem !important; }
            .mr-sm-n1,
            .mx-sm-n1 {
              margin-right: -0.25rem !important; }
            .mb-sm-n1,
            .my-sm-n1 {
              margin-bottom: -0.25rem !important; }
            .ml-sm-n1,
            .mx-sm-n1 {
              margin-left: -0.25rem !important; }
            .m-sm-n2 {
              margin: -0.5rem !important; }
            .mt-sm-n2,
            .my-sm-n2 {
              margin-top: -0.5rem !important; }
            .mr-sm-n2,
            .mx-sm-n2 {
              margin-right: -0.5rem !important; }
            .mb-sm-n2,
            .my-sm-n2 {
              margin-bottom: -0.5rem !important; }
            .ml-sm-n2,
            .mx-sm-n2 {
              margin-left: -0.5rem !important; }
            .m-sm-n3 {
              margin: -1rem !important; }
            .mt-sm-n3,
            .my-sm-n3 {
              margin-top: -1rem !important; }
            .mr-sm-n3,
            .mx-sm-n3 {
              margin-right: -1rem !important; }
            .mb-sm-n3,
            .my-sm-n3 {
              margin-bottom: -1rem !important; }
            .ml-sm-n3,
            .mx-sm-n3 {
              margin-left: -1rem !important; }
            .m-sm-n4 {
              margin: -1.5rem !important; }
            .mt-sm-n4,
            .my-sm-n4 {
              margin-top: -1.5rem !important; }
            .mr-sm-n4,
            .mx-sm-n4 {
              margin-right: -1.5rem !important; }
            .mb-sm-n4,
            .my-sm-n4 {
              margin-bottom: -1.5rem !important; }
            .ml-sm-n4,
            .mx-sm-n4 {
              margin-left: -1.5rem !important; }
            .m-sm-n5 {
              margin: -3rem !important; }
            .mt-sm-n5,
            .my-sm-n5 {
              margin-top: -3rem !important; }
            .mr-sm-n5,
            .mx-sm-n5 {
              margin-right: -3rem !important; }
            .mb-sm-n5,
            .my-sm-n5 {
              margin-bottom: -3rem !important; }
            .ml-sm-n5,
            .mx-sm-n5 {
              margin-left: -3rem !important; }
            .m-sm-auto {
              margin: auto !important; }
            .mt-sm-auto,
            .my-sm-auto {
              margin-top: auto !important; }
            .mr-sm-auto,
            .mx-sm-auto {
              margin-right: auto !important; }
            .mb-sm-auto,
            .my-sm-auto {
              margin-bottom: auto !important; }
            .ml-sm-auto,
            .mx-sm-auto {
              margin-left: auto !important; } }
          
          @media (min-width: 768px) {
            .m-md-0 {
              margin: 0 !important; }
            .mt-md-0,
            .my-md-0 {
              margin-top: 0 !important; }
            .mr-md-0,
            .mx-md-0 {
              margin-right: 0 !important; }
            .mb-md-0,
            .my-md-0 {
              margin-bottom: 0 !important; }
            .ml-md-0,
            .mx-md-0 {
              margin-left: 0 !important; }
            .m-md-1 {
              margin: 0.25rem !important; }
            .mt-md-1,
            .my-md-1 {
              margin-top: 0.25rem !important; }
            .mr-md-1,
            .mx-md-1 {
              margin-right: 0.25rem !important; }
            .mb-md-1,
            .my-md-1 {
              margin-bottom: 0.25rem !important; }
            .ml-md-1,
            .mx-md-1 {
              margin-left: 0.25rem !important; }
            .m-md-2 {
              margin: 0.5rem !important; }
            .mt-md-2,
            .my-md-2 {
              margin-top: 0.5rem !important; }
            .mr-md-2,
            .mx-md-2 {
              margin-right: 0.5rem !important; }
            .mb-md-2,
            .my-md-2 {
              margin-bottom: 0.5rem !important; }
            .ml-md-2,
            .mx-md-2 {
              margin-left: 0.5rem !important; }
            .m-md-3 {
              margin: 1rem !important; }
            .mt-md-3,
            .my-md-3 {
              margin-top: 1rem !important; }
            .mr-md-3,
            .mx-md-3 {
              margin-right: 1rem !important; }
            .mb-md-3,
            .my-md-3 {
              margin-bottom: 1rem !important; }
            .ml-md-3,
            .mx-md-3 {
              margin-left: 1rem !important; }
            .m-md-4 {
              margin: 1.5rem !important; }
            .mt-md-4,
            .my-md-4 {
              margin-top: 1.5rem !important; }
            .mr-md-4,
            .mx-md-4 {
              margin-right: 1.5rem !important; }
            .mb-md-4,
            .my-md-4 {
              margin-bottom: 1.5rem !important; }
            .ml-md-4,
            .mx-md-4 {
              margin-left: 1.5rem !important; }
            .m-md-5 {
              margin: 3rem !important; }
            .mt-md-5,
            .my-md-5 {
              margin-top: 3rem !important; }
            .mr-md-5,
            .mx-md-5 {
              margin-right: 3rem !important; }
            .mb-md-5,
            .my-md-5 {
              margin-bottom: 3rem !important; }
            .ml-md-5,
            .mx-md-5 {
              margin-left: 3rem !important; }
            .p-md-0 {
              padding: 0 !important; }
            .pt-md-0,
            .py-md-0 {
              padding-top: 0 !important; }
            .pr-md-0,
            .px-md-0 {
              padding-right: 0 !important; }
            .pb-md-0,
            .py-md-0 {
              padding-bottom: 0 !important; }
            .pl-md-0,
            .px-md-0 {
              padding-left: 0 !important; }
            .p-md-1 {
              padding: 0.25rem !important; }
            .pt-md-1,
            .py-md-1 {
              padding-top: 0.25rem !important; }
            .pr-md-1,
            .px-md-1 {
              padding-right: 0.25rem !important; }
            .pb-md-1,
            .py-md-1 {
              padding-bottom: 0.25rem !important; }
            .pl-md-1,
            .px-md-1 {
              padding-left: 0.25rem !important; }
            .p-md-2 {
              padding: 0.5rem !important; }
            .pt-md-2,
            .py-md-2 {
              padding-top: 0.5rem !important; }
            .pr-md-2,
            .px-md-2 {
              padding-right: 0.5rem !important; }
            .pb-md-2,
            .py-md-2 {
              padding-bottom: 0.5rem !important; }
            .pl-md-2,
            .px-md-2 {
              padding-left: 0.5rem !important; }
            .p-md-3 {
              padding: 1rem !important; }
            .pt-md-3,
            .py-md-3 {
              padding-top: 1rem !important; }
            .pr-md-3,
            .px-md-3 {
              padding-right: 1rem !important; }
            .pb-md-3,
            .py-md-3 {
              padding-bottom: 1rem !important; }
            .pl-md-3,
            .px-md-3 {
              padding-left: 1rem !important; }
            .p-md-4 {
              padding: 1.5rem !important; }
            .pt-md-4,
            .py-md-4 {
              padding-top: 1.5rem !important; }
            .pr-md-4,
            .px-md-4 {
              padding-right: 1.5rem !important; }
            .pb-md-4,
            .py-md-4 {
              padding-bottom: 1.5rem !important; }
            .pl-md-4,
            .px-md-4 {
              padding-left: 1.5rem !important; }
            .p-md-5 {
              padding: 3rem !important; }
            .pt-md-5,
            .py-md-5 {
              padding-top: 3rem !important; }
            .pr-md-5,
            .px-md-5 {
              padding-right: 3rem !important; }
            .pb-md-5,
            .py-md-5 {
              padding-bottom: 3rem !important; }
            .pl-md-5,
            .px-md-5 {
              padding-left: 3rem !important; }
            .m-md-n1 {
              margin: -0.25rem !important; }
            .mt-md-n1,
            .my-md-n1 {
              margin-top: -0.25rem !important; }
            .mr-md-n1,
            .mx-md-n1 {
              margin-right: -0.25rem !important; }
            .mb-md-n1,
            .my-md-n1 {
              margin-bottom: -0.25rem !important; }
            .ml-md-n1,
            .mx-md-n1 {
              margin-left: -0.25rem !important; }
            .m-md-n2 {
              margin: -0.5rem !important; }
            .mt-md-n2,
            .my-md-n2 {
              margin-top: -0.5rem !important; }
            .mr-md-n2,
            .mx-md-n2 {
              margin-right: -0.5rem !important; }
            .mb-md-n2,
            .my-md-n2 {
              margin-bottom: -0.5rem !important; }
            .ml-md-n2,
            .mx-md-n2 {
              margin-left: -0.5rem !important; }
            .m-md-n3 {
              margin: -1rem !important; }
            .mt-md-n3,
            .my-md-n3 {
              margin-top: -1rem !important; }
            .mr-md-n3,
            .mx-md-n3 {
              margin-right: -1rem !important; }
            .mb-md-n3,
            .my-md-n3 {
              margin-bottom: -1rem !important; }
            .ml-md-n3,
            .mx-md-n3 {
              margin-left: -1rem !important; }
            .m-md-n4 {
              margin: -1.5rem !important; }
            .mt-md-n4,
            .my-md-n4 {
              margin-top: -1.5rem !important; }
            .mr-md-n4,
            .mx-md-n4 {
              margin-right: -1.5rem !important; }
            .mb-md-n4,
            .my-md-n4 {
              margin-bottom: -1.5rem !important; }
            .ml-md-n4,
            .mx-md-n4 {
              margin-left: -1.5rem !important; }
            .m-md-n5 {
              margin: -3rem !important; }
            .mt-md-n5,
            .my-md-n5 {
              margin-top: -3rem !important; }
            .mr-md-n5,
            .mx-md-n5 {
              margin-right: -3rem !important; }
            .mb-md-n5,
            .my-md-n5 {
              margin-bottom: -3rem !important; }
            .ml-md-n5,
            .mx-md-n5 {
              margin-left: -3rem !important; }
            .m-md-auto {
              margin: auto !important; }
            .mt-md-auto,
            .my-md-auto {
              margin-top: auto !important; }
            .mr-md-auto,
            .mx-md-auto {
              margin-right: auto !important; }
            .mb-md-auto,
            .my-md-auto {
              margin-bottom: auto !important; }
            .ml-md-auto,
            .mx-md-auto {
              margin-left: auto !important; } }
          
          @media (min-width: 992px) {
            .m-lg-0 {
              margin: 0 !important; }
            .mt-lg-0,
            .my-lg-0 {
              margin-top: 0 !important; }
            .mr-lg-0,
            .mx-lg-0 {
              margin-right: 0 !important; }
            .mb-lg-0,
            .my-lg-0 {
              margin-bottom: 0 !important; }
            .ml-lg-0,
            .mx-lg-0 {
              margin-left: 0 !important; }
            .m-lg-1 {
              margin: 0.25rem !important; }
            .mt-lg-1,
            .my-lg-1 {
              margin-top: 0.25rem !important; }
            .mr-lg-1,
            .mx-lg-1 {
              margin-right: 0.25rem !important; }
            .mb-lg-1,
            .my-lg-1 {
              margin-bottom: 0.25rem !important; }
            .ml-lg-1,
            .mx-lg-1 {
              margin-left: 0.25rem !important; }
            .m-lg-2 {
              margin: 0.5rem !important; }
            .mt-lg-2,
            .my-lg-2 {
              margin-top: 0.5rem !important; }
            .mr-lg-2,
            .mx-lg-2 {
              margin-right: 0.5rem !important; }
            .mb-lg-2,
            .my-lg-2 {
              margin-bottom: 0.5rem !important; }
            .ml-lg-2,
            .mx-lg-2 {
              margin-left: 0.5rem !important; }
            .m-lg-3 {
              margin: 1rem !important; }
            .mt-lg-3,
            .my-lg-3 {
              margin-top: 1rem !important; }
            .mr-lg-3,
            .mx-lg-3 {
              margin-right: 1rem !important; }
            .mb-lg-3,
            .my-lg-3 {
              margin-bottom: 1rem !important; }
            .ml-lg-3,
            .mx-lg-3 {
              margin-left: 1rem !important; }
            .m-lg-4 {
              margin: 1.5rem !important; }
            .mt-lg-4,
            .my-lg-4 {
              margin-top: 1.5rem !important; }
            .mr-lg-4,
            .mx-lg-4 {
              margin-right: 1.5rem !important; }
            .mb-lg-4,
            .my-lg-4 {
              margin-bottom: 1.5rem !important; }
            .ml-lg-4,
            .mx-lg-4 {
              margin-left: 1.5rem !important; }
            .m-lg-5 {
              margin: 3rem !important; }
            .mt-lg-5,
            .my-lg-5 {
              margin-top: 3rem !important; }
            .mr-lg-5,
            .mx-lg-5 {
              margin-right: 3rem !important; }
            .mb-lg-5,
            .my-lg-5 {
              margin-bottom: 3rem !important; }
            .ml-lg-5,
            .mx-lg-5 {
              margin-left: 3rem !important; }
            .p-lg-0 {
              padding: 0 !important; }
            .pt-lg-0,
            .py-lg-0 {
              padding-top: 0 !important; }
            .pr-lg-0,
            .px-lg-0 {
              padding-right: 0 !important; }
            .pb-lg-0,
            .py-lg-0 {
              padding-bottom: 0 !important; }
            .pl-lg-0,
            .px-lg-0 {
              padding-left: 0 !important; }
            .p-lg-1 {
              padding: 0.25rem !important; }
            .pt-lg-1,
            .py-lg-1 {
              padding-top: 0.25rem !important; }
            .pr-lg-1,
            .px-lg-1 {
              padding-right: 0.25rem !important; }
            .pb-lg-1,
            .py-lg-1 {
              padding-bottom: 0.25rem !important; }
            .pl-lg-1,
            .px-lg-1 {
              padding-left: 0.25rem !important; }
            .p-lg-2 {
              padding: 0.5rem !important; }
            .pt-lg-2,
            .py-lg-2 {
              padding-top: 0.5rem !important; }
            .pr-lg-2,
            .px-lg-2 {
              padding-right: 0.5rem !important; }
            .pb-lg-2,
            .py-lg-2 {
              padding-bottom: 0.5rem !important; }
            .pl-lg-2,
            .px-lg-2 {
              padding-left: 0.5rem !important; }
            .p-lg-3 {
              padding: 1rem !important; }
            .pt-lg-3,
            .py-lg-3 {
              padding-top: 1rem !important; }
            .pr-lg-3,
            .px-lg-3 {
              padding-right: 1rem !important; }
            .pb-lg-3,
            .py-lg-3 {
              padding-bottom: 1rem !important; }
            .pl-lg-3,
            .px-lg-3 {
              padding-left: 1rem !important; }
            .p-lg-4 {
              padding: 1.5rem !important; }
            .pt-lg-4,
            .py-lg-4 {
              padding-top: 1.5rem !important; }
            .pr-lg-4,
            .px-lg-4 {
              padding-right: 1.5rem !important; }
            .pb-lg-4,
            .py-lg-4 {
              padding-bottom: 1.5rem !important; }
            .pl-lg-4,
            .px-lg-4 {
              padding-left: 1.5rem !important; }
            .p-lg-5 {
              padding: 3rem !important; }
            .pt-lg-5,
            .py-lg-5 {
              padding-top: 3rem !important; }
            .pr-lg-5,
            .px-lg-5 {
              padding-right: 3rem !important; }
            .pb-lg-5,
            .py-lg-5 {
              padding-bottom: 3rem !important; }
            .pl-lg-5,
            .px-lg-5 {
              padding-left: 3rem !important; }
            .m-lg-n1 {
              margin: -0.25rem !important; }
            .mt-lg-n1,
            .my-lg-n1 {
              margin-top: -0.25rem !important; }
            .mr-lg-n1,
            .mx-lg-n1 {
              margin-right: -0.25rem !important; }
            .mb-lg-n1,
            .my-lg-n1 {
              margin-bottom: -0.25rem !important; }
            .ml-lg-n1,
            .mx-lg-n1 {
              margin-left: -0.25rem !important; }
            .m-lg-n2 {
              margin: -0.5rem !important; }
            .mt-lg-n2,
            .my-lg-n2 {
              margin-top: -0.5rem !important; }
            .mr-lg-n2,
            .mx-lg-n2 {
              margin-right: -0.5rem !important; }
            .mb-lg-n2,
            .my-lg-n2 {
              margin-bottom: -0.5rem !important; }
            .ml-lg-n2,
            .mx-lg-n2 {
              margin-left: -0.5rem !important; }
            .m-lg-n3 {
              margin: -1rem !important; }
            .mt-lg-n3,
            .my-lg-n3 {
              margin-top: -1rem !important; }
            .mr-lg-n3,
            .mx-lg-n3 {
              margin-right: -1rem !important; }
            .mb-lg-n3,
            .my-lg-n3 {
              margin-bottom: -1rem !important; }
            .ml-lg-n3,
            .mx-lg-n3 {
              margin-left: -1rem !important; }
            .m-lg-n4 {
              margin: -1.5rem !important; }
            .mt-lg-n4,
            .my-lg-n4 {
              margin-top: -1.5rem !important; }
            .mr-lg-n4,
            .mx-lg-n4 {
              margin-right: -1.5rem !important; }
            .mb-lg-n4,
            .my-lg-n4 {
              margin-bottom: -1.5rem !important; }
            .ml-lg-n4,
            .mx-lg-n4 {
              margin-left: -1.5rem !important; }
            .m-lg-n5 {
              margin: -3rem !important; }
            .mt-lg-n5,
            .my-lg-n5 {
              margin-top: -3rem !important; }
            .mr-lg-n5,
            .mx-lg-n5 {
              margin-right: -3rem !important; }
            .mb-lg-n5,
            .my-lg-n5 {
              margin-bottom: -3rem !important; }
            .ml-lg-n5,
            .mx-lg-n5 {
              margin-left: -3rem !important; }
            .m-lg-auto {
              margin: auto !important; }
            .mt-lg-auto,
            .my-lg-auto {
              margin-top: auto !important; }
            .mr-lg-auto,
            .mx-lg-auto {
              margin-right: auto !important; }
            .mb-lg-auto,
            .my-lg-auto {
              margin-bottom: auto !important; }
            .ml-lg-auto,
            .mx-lg-auto {
              margin-left: auto !important; } }
          
          @media (min-width: 1200px) {
            .m-xl-0 {
              margin: 0 !important; }
            .mt-xl-0,
            .my-xl-0 {
              margin-top: 0 !important; }
            .mr-xl-0,
            .mx-xl-0 {
              margin-right: 0 !important; }
            .mb-xl-0,
            .my-xl-0 {
              margin-bottom: 0 !important; }
            .ml-xl-0,
            .mx-xl-0 {
              margin-left: 0 !important; }
            .m-xl-1 {
              margin: 0.25rem !important; }
            .mt-xl-1,
            .my-xl-1 {
              margin-top: 0.25rem !important; }
            .mr-xl-1,
            .mx-xl-1 {
              margin-right: 0.25rem !important; }
            .mb-xl-1,
            .my-xl-1 {
              margin-bottom: 0.25rem !important; }
            .ml-xl-1,
            .mx-xl-1 {
              margin-left: 0.25rem !important; }
            .m-xl-2 {
              margin: 0.5rem !important; }
            .mt-xl-2,
            .my-xl-2 {
              margin-top: 0.5rem !important; }
            .mr-xl-2,
            .mx-xl-2 {
              margin-right: 0.5rem !important; }
            .mb-xl-2,
            .my-xl-2 {
              margin-bottom: 0.5rem !important; }
            .ml-xl-2,
            .mx-xl-2 {
              margin-left: 0.5rem !important; }
            .m-xl-3 {
              margin: 1rem !important; }
            .mt-xl-3,
            .my-xl-3 {
              margin-top: 1rem !important; }
            .mr-xl-3,
            .mx-xl-3 {
              margin-right: 1rem !important; }
            .mb-xl-3,
            .my-xl-3 {
              margin-bottom: 1rem !important; }
            .ml-xl-3,
            .mx-xl-3 {
              margin-left: 1rem !important; }
            .m-xl-4 {
              margin: 1.5rem !important; }
            .mt-xl-4,
            .my-xl-4 {
              margin-top: 1.5rem !important; }
            .mr-xl-4,
            .mx-xl-4 {
              margin-right: 1.5rem !important; }
            .mb-xl-4,
            .my-xl-4 {
              margin-bottom: 1.5rem !important; }
            .ml-xl-4,
            .mx-xl-4 {
              margin-left: 1.5rem !important; }
            .m-xl-5 {
              margin: 3rem !important; }
            .mt-xl-5,
            .my-xl-5 {
              margin-top: 3rem !important; }
            .mr-xl-5,
            .mx-xl-5 {
              margin-right: 3rem !important; }
            .mb-xl-5,
            .my-xl-5 {
              margin-bottom: 3rem !important; }
            .ml-xl-5,
            .mx-xl-5 {
              margin-left: 3rem !important; }
            .p-xl-0 {
              padding: 0 !important; }
            .pt-xl-0,
            .py-xl-0 {
              padding-top: 0 !important; }
            .pr-xl-0,
            .px-xl-0 {
              padding-right: 0 !important; }
            .pb-xl-0,
            .py-xl-0 {
              padding-bottom: 0 !important; }
            .pl-xl-0,
            .px-xl-0 {
              padding-left: 0 !important; }
            .p-xl-1 {
              padding: 0.25rem !important; }
            .pt-xl-1,
            .py-xl-1 {
              padding-top: 0.25rem !important; }
            .pr-xl-1,
            .px-xl-1 {
              padding-right: 0.25rem !important; }
            .pb-xl-1,
            .py-xl-1 {
              padding-bottom: 0.25rem !important; }
            .pl-xl-1,
            .px-xl-1 {
              padding-left: 0.25rem !important; }
            .p-xl-2 {
              padding: 0.5rem !important; }
            .pt-xl-2,
            .py-xl-2 {
              padding-top: 0.5rem !important; }
            .pr-xl-2,
            .px-xl-2 {
              padding-right: 0.5rem !important; }
            .pb-xl-2,
            .py-xl-2 {
              padding-bottom: 0.5rem !important; }
            .pl-xl-2,
            .px-xl-2 {
              padding-left: 0.5rem !important; }
            .p-xl-3 {
              padding: 1rem !important; }
            .pt-xl-3,
            .py-xl-3 {
              padding-top: 1rem !important; }
            .pr-xl-3,
            .px-xl-3 {
              padding-right: 1rem !important; }
            .pb-xl-3,
            .py-xl-3 {
              padding-bottom: 1rem !important; }
            .pl-xl-3,
            .px-xl-3 {
              padding-left: 1rem !important; }
            .p-xl-4 {
              padding: 1.5rem !important; }
            .pt-xl-4,
            .py-xl-4 {
              padding-top: 1.5rem !important; }
            .pr-xl-4,
            .px-xl-4 {
              padding-right: 1.5rem !important; }
            .pb-xl-4,
            .py-xl-4 {
              padding-bottom: 1.5rem !important; }
            .pl-xl-4,
            .px-xl-4 {
              padding-left: 1.5rem !important; }
            .p-xl-5 {
              padding: 3rem !important; }
            .pt-xl-5,
            .py-xl-5 {
              padding-top: 3rem !important; }
            .pr-xl-5,
            .px-xl-5 {
              padding-right: 3rem !important; }
            .pb-xl-5,
            .py-xl-5 {
              padding-bottom: 3rem !important; }
            .pl-xl-5,
            .px-xl-5 {
              padding-left: 3rem !important; }
            .m-xl-n1 {
              margin: -0.25rem !important; }
            .mt-xl-n1,
            .my-xl-n1 {
              margin-top: -0.25rem !important; }
            .mr-xl-n1,
            .mx-xl-n1 {
              margin-right: -0.25rem !important; }
            .mb-xl-n1,
            .my-xl-n1 {
              margin-bottom: -0.25rem !important; }
            .ml-xl-n1,
            .mx-xl-n1 {
              margin-left: -0.25rem !important; }
            .m-xl-n2 {
              margin: -0.5rem !important; }
            .mt-xl-n2,
            .my-xl-n2 {
              margin-top: -0.5rem !important; }
            .mr-xl-n2,
            .mx-xl-n2 {
              margin-right: -0.5rem !important; }
            .mb-xl-n2,
            .my-xl-n2 {
              margin-bottom: -0.5rem !important; }
            .ml-xl-n2,
            .mx-xl-n2 {
              margin-left: -0.5rem !important; }
            .m-xl-n3 {
              margin: -1rem !important; }
            .mt-xl-n3,
            .my-xl-n3 {
              margin-top: -1rem !important; }
            .mr-xl-n3,
            .mx-xl-n3 {
              margin-right: -1rem !important; }
            .mb-xl-n3,
            .my-xl-n3 {
              margin-bottom: -1rem !important; }
            .ml-xl-n3,
            .mx-xl-n3 {
              margin-left: -1rem !important; }
            .m-xl-n4 {
              margin: -1.5rem !important; }
            .mt-xl-n4,
            .my-xl-n4 {
              margin-top: -1.5rem !important; }
            .mr-xl-n4,
            .mx-xl-n4 {
              margin-right: -1.5rem !important; }
            .mb-xl-n4,
            .my-xl-n4 {
              margin-bottom: -1.5rem !important; }
            .ml-xl-n4,
            .mx-xl-n4 {
              margin-left: -1.5rem !important; }
            .m-xl-n5 {
              margin: -3rem !important; }
            .mt-xl-n5,
            .my-xl-n5 {
              margin-top: -3rem !important; }
            .mr-xl-n5,
            .mx-xl-n5 {
              margin-right: -3rem !important; }
            .mb-xl-n5,
            .my-xl-n5 {
              margin-bottom: -3rem !important; }
            .ml-xl-n5,
            .mx-xl-n5 {
              margin-left: -3rem !important; }
            .m-xl-auto {
              margin: auto !important; }
            .mt-xl-auto,
            .my-xl-auto {
              margin-top: auto !important; }
            .mr-xl-auto,
            .mx-xl-auto {
              margin-right: auto !important; }
            .mb-xl-auto,
            .my-xl-auto {
              margin-bottom: auto !important; }
            .ml-xl-auto,
            .mx-xl-auto {
              margin-left: auto !important; } }

              .nav-tabs {
                border-bottom: 1px solid #dee2e6; }
                .nav-tabs .nav-itemPX {
                  margin-bottom: -1px; }
                .nav-tabs .nav-linkPX {
                  border: 1px solid transparent;
                  border-top-left-radius: 0.25rem;
                  border-top-right-radius: 0.25rem; }
                  .nav-tabs .nav-linkPX:hover, .nav-tabs .nav-linkPX:focus {
                    border-color: #e9ecef #e9ecef #dee2e6; }
                  .nav-tabs .nav-linkPX.disabled {
                    color: #6c757d;
                    background-color: transparent;
                    border-color: transparent; }
                .nav-tabs .nav-linkPX.active,
                .nav-tabs .nav-itemPX.show .nav-linkPX {
                  color: #495057;
                  background-color: #fff;
                  border-color: #dee2e6 #dee2e6 #fff; }
                .nav-tabs .dropdownPX-menu {
                  margin-top: -1px;
                  border-top-left-radius: 0;
                  border-top-right-radius: 0; }
                  .nav-linkPX {
                    display: block;
                    padding: 0.5rem 1rem; }
                    .nav-linkPX:hover, .nav-linkPX:focus {
                      text-decoration: none; }
                    .nav-linkPX.disabled {
                      color: #6c757d;
                      pointer-events: none;
                      cursor: default; }
                                
                      .dropdownPX-toggle:empty::after {
                        margin-left: 0; }
                    
                    .dropdownPX-menu {
                      position: absolute;
                      top: 100%;
                      left: 0;
                      z-index: 1000;
                      display: none;
                      float: left;
                      min-width: 10rem;
                      padding: 0.5rem 0;
                      margin: 0.125rem 0 0;
                      font-size: 1rem;
                      color: #212529;
                      text-align: left;
                      list-style: none;
                      background-color: #fff;
                      background-clip: padding-box;
                      border: 1px solid rgba(0, 0, 0, 0.15);
                      border-radius: 0.25rem; }
                    
                    .dropdownPX-menu-left {
                      right: auto;
                      left: 0; }
                    
                    .dropdownPX-menu-right {
                      right: 0;
                      left: auto; }
                    
                    @media (min-width: 576px) {
                      .dropdownPX-menu-sm-left {
                        right: auto;
                        left: 0; }
                      .dropdownPX-menu-sm-right {
                        right: 0;
                        left: auto; } }
                    
                    @media (min-width: 768px) {
                      .dropdownPX-menu-md-left {
                        right: auto;
                        left: 0; }
                      .dropdownPX-menu-md-right {
                        right: 0;
                        left: auto; } }
                    
                    @media (min-width: 992px) {
                      .dropdownPX-menu-lg-left {
                        right: auto;
                        left: 0; }
                      .dropdownPX-menu-lg-right {
                        right: 0;
                        left: auto; } }
                    
                    @media (min-width: 1200px) {
                      .dropdownPX-menu-xl-left {
                        right: auto;
                        left: 0; }
                      .dropdownPX-menu-xl-right {
                        right: 0;
                        left: auto; } }
                    
                    .dropup .dropdownPX-menu {
                      top: auto;
                      bottom: 100%;
                      margin-top: 0;
                      margin-bottom: 0.125rem; }
                    
                    .dropup .dropdownPX-toggle::after {
                      display: inline-block;
                      margin-left: 0.255em;
                      vertical-align: 0.255em;
                      content: "";
                      border-top: 0;
                      border-right: 0.3em solid transparent;
                      border-bottom: 0.3em solid;
                      border-left: 0.3em solid transparent; }
                    
                    .dropup .dropdownPX-toggle:empty::after {
                      margin-left: 0; }
                    
                    .dropright .dropdownPX-menu {
                      top: 0;
                      right: auto;
                      left: 100%;
                      margin-top: 0;
                      margin-left: 0.125rem; }
                    
                    .dropright .dropdownPX-toggle::after {
                      display: inline-block;
                      margin-left: 0.255em;
                      vertical-align: 0.255em;
                      content: "";
                      border-top: 0.3em solid transparent;
                      border-right: 0;
                      border-bottom: 0.3em solid transparent;
                      border-left: 0.3em solid; }
                    
                    .dropright .dropdownPX-toggle:empty::after {
                      margin-left: 0; }
                    
                    .dropright .dropdownPX-toggle::after {
                      vertical-align: 0; }
                    
                    .dropleft .dropdownPX-menu {
                      top: 0;
                      right: 100%;
                      left: auto;
                      margin-top: 0;
                      margin-right: 0.125rem; }
                    
                    .dropleft .dropdownPX-toggle::after {
                      display: inline-block;
                      margin-left: 0.255em;
                      vertical-align: 0.255em;
                      content: ""; }
                    
                    .dropleft .dropdownPX-toggle::after {
                      display: none; }
                    
                    .dropleft .dropdownPX-toggle::before {
                      display: inline-block;
                      margin-right: 0.255em;
                      vertical-align: 0.255em;
                      content: "";
                      border-top: 0.3em solid transparent;
                      border-right: 0.3em solid;
                      border-bottom: 0.3em solid transparent; }
                    
                    .dropleft .dropdownPX-toggle:empty::after {
                      margin-left: 0; }
                    
                    .dropleft .dropdownPX-toggle::before {
                      vertical-align: 0; }
                    
                    .dropdownPX-menu[x-placement^="top"], .dropdownPX-menu[x-placement^="right"], .dropdownPX-menu[x-placement^="bottom"], .dropdownPX-menu[x-placement^="left"] {
                      right: auto;
                      bottom: auto; }
                    
                    .dropdownPX-divider {
                      height: 0;
                      margin: 0.5rem 0;
                      overflow: hidden;
                      border-top: 1px solid #e9ecef; }
                    
                    .dropdownPX-item {
                      display: block;
                      width: 100%;
                      padding: 0.25rem 1.5rem;
                      clear: both;
                      font-weight: 400;
                      color: #212529;
                      text-align: inherit;
                      white-space: nowrap;
                      background-color: transparent;
                      border: 0; }
                      .dropdownPX-item:hover, .dropdownPX-item:focus {
                        color: #16181b;
                        text-decoration: none;
                        background-color: #f8f9fa; }
                      .dropdownPX-item.active, .dropdownPX-item:active {
                        color: #fff;
                        text-decoration: none;
                        background-color: #007bff; }
                      .dropdownPX-item.disabled, .dropdownPX-item:disabled {
                        color: #6c757d;
                        pointer-events: none;
                        background-color: transparent; }
                    
                    .dropdownPX-menu.show {
                      display: block; }
                    
                    .dropdownPX-header {
                      display: block;
                      padding: 0.5rem 1.5rem;
                      margin-bottom: 0;
                      font-size: 0.875rem;
                      color: #6c757d;
                      white-space: nowrap; }
                    
                    .dropdownPX-item-text {
                      display: block;
                      padding: 0.25rem 1.5rem;
                      color: #212529; }
                    
                    .dropdownPX-toggle-split {
                      padding-right: 0.5625rem;
                      padding-left: 0.5625rem; }
                      .dropdownPX-toggle-split::after,
                      .dropup .dropdownPX-toggle-split::after,
                      .dropright .dropdownPX-toggle-split::after {
                        margin-left: 0; }
                      .dropleft .dropdownPX-toggle-split::before {
                        margin-right: 0; }     
                                              

                        .section1{
height: 1000px;
                        }
                        
                        .section2{
height: 1000px;
                        }  
                        
                        
  
@media (min-width: 992px){

.languagebutton {
  align-items: center;
  width: auto;
  height: 40px;
  display: flex;
  position: relative;
  margin-left: 20px;
  color: white;
  
 
  
}


.languagebutton:hover{
  
  color: lightskyblue;
}


 .langicon-header {
  height: 18px;
  width: auto;
  fill: white;
  margin: auto;
  margin-right: 8px;
}

.language {
  font-family: 'LatoMid';
  font-size: 17px;
}
}
@media (max-width: 1115px){
  .languagebutton {
    align-items: center;
    width: auto;
    height: 40px;
    display: flex;
    position: relative;
    margin-left: 20px;
    
  }
  
 .langicon-header {
    height: 15px;
    width: auto;
    fill: white;
    margin: auto;
  
    margin-right: 8px;
  }
  
  .language {
    font-family: 'LatoBold';
    font-size: 13px;
    color: white;
    
  }

}

  @font-face {
    font-family: 'LatoBold';
    font-style: normal;
    font-weight: 700;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Bold.ttf);
  }
  @font-face {
    font-family: 'LatoBlack';
    font-style: normal;
    font-weight: 900;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Black.ttf);
  }
  
  @font-face {
    font-family: 'LatoRegular';
    font-style: normal;
    font-weight: 400;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Regular.ttf);
  }
  @font-face {
    font-family: 'LatoSemi';
    font-style: normal;
    font-weight: 600;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.ttf);
  }
  @font-face {
    font-family: 'LatoMid';
    font-style: normal;
    font-weight: 600;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Medium.ttf);
  }



</style>
